import { render, staticRenderFns } from "./MustConfigureBranchOffices.vue?vue&type=template&id=4282acb2&scoped=true&"
import script from "./MustConfigureBranchOffices.vue?vue&type=script&lang=js&"
export * from "./MustConfigureBranchOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282acb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
